class FruechteboxRegularity extends HTMLElement {
  constructor() {
    super();

    this.moneyFormat = this.dataset.moneyFormat;
    this.shippingPrice = this.dataset.shippingPrice;

    this.fruechteboxGesamttotalElement = document.querySelector("fruechtebox-gesamttotal");
  }

  connectedCallback() {
    this.initElements();
    this.initState();
    this.updateFieldsMax();
    this.updateHiddenInput();
  }

  initElements() {
    this.regularityFieldset = this.querySelector('[data-reglarity]');
    this.regularity = parseInt(new URLSearchParams(window.location.search).get('frequency')) || null;
    const initInputElement = this.regularityFieldset.querySelector(`input[name="contact[Regelmässigkeit]"][data-value="${this.regularity}"]`);
    this.deliveryDaysFieldset = this.querySelector('[data-delivery-days]');
    this.deliveryDaysFields = Array.from(
      this.deliveryDaysFieldset.querySelectorAll('input[type="number"]')
    );
    this.hiddenDaysInput = this.querySelector('input[name="contact[anzahl boxen]"]');
    this.visibleDaysInput = document.querySelector('#anzahl-boxen');
    this.visibleInput = document.querySelector("#regelmässigkeit");
    this.visibleInput2 = document.querySelector("#fruechtebox-frequency-title");

    this.addEventListeners();

    if (initInputElement) { initInputElement.checked = true; initInputElement.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  initState() {
    const checkedInput = this.regularityFieldset.querySelector('input[name="contact[Regelmässigkeit]"]:checked');
    this.regularity = parseInt(checkedInput?.dataset.value, 10) || 0;
  }

  addEventListeners() {
    this.regularityFieldset.addEventListener('change', this.onVariantChange.bind(this));

    this.deliveryDaysFields.forEach(field => {
      field.addEventListener('input', () => this.onDayInput(field));
    });
  }

  onVariantChange(e) {
    const newValue = parseInt(e.target?.dataset?.value, 10);
    if (!isNaN(newValue)) {
      this.regularity = newValue;
      this.resetFields();
      this.updateHiddenInput();
      this.updateFieldsMax();
      const newStringValue = e.target.value;
      this.visibleInput.textContent = newStringValue;
      if (this.visibleInput2) this.visibleInput2.textContent = newStringValue;

      const currentVariant = document.querySelector('fruechtebox-radios').currentVariant;
      const currentVariantSubPrice = this.moneyFormat.replace("{{amount}}", (currentVariant.price * this.regularity / 100).toFixed(2));
      const shippingSubPrice = this.moneyFormat.replace("{{amount}}", (Number(this.shippingPrice) * this.regularity / 100).toFixed(2));
      const subscriptionPrice = this.moneyFormat.replace("{{amount}}", ((currentVariant.price + Number(this.shippingPrice)) * this.regularity / 100).toFixed(2));

      const fruechteboxSubtotal = document.querySelector("#fruechtebox-subtotal");
      fruechteboxSubtotal.querySelector('[name="contact[preis pro früchtebox]"]').textContent = currentVariantSubPrice;
      fruechteboxSubtotal.querySelector(".price-item.price-item--regular").textContent = currentVariantSubPrice;

      const fruechteboxShipping = document.querySelector("#fruechtebox-shipping");
      fruechteboxShipping.querySelector('[name="contact[lieferkosten]"]').textContent = shippingSubPrice;
      fruechteboxShipping.querySelector(".price-item.price-item--regular").textContent = shippingSubPrice;
      document.querySelector("#total-delivery-cost").textContent = shippingSubPrice;

      const fruechteboxTotal = document.querySelector("#fruechtebox-total");
      fruechteboxTotal.querySelector(".price-item.price-item--regular").textContent = subscriptionPrice;

      this.fruechteboxGesamttotalElement.updateTotal();
    }
  }

  onDayInput(field) {
    const max = parseInt(field.max, 10);
    const value = parseInt(field.value, 10);

    if (value > max) {
      field.value = max;
    }

    this.updateFieldsMax();
    this.updateHiddenInput();
  }

  getTotalDays() {
    return this.deliveryDaysFields.reduce((sum, field) => sum + (+field.value || 0), 0);
  }

  resetFields() {
    this.deliveryDaysFields.forEach((field, index) => {
      if(index == 0 || (this.regularity == 2 && index == 2)) {
        field.value = 1;
      } else {
        field.value = '';
      }
      field.max = this.regularity;
      field.disabled = false;
    });
  }

  updateFieldsMax() {
    const total = this.getTotalDays();
    const remaining = this.regularity - total;

    this.deliveryDaysFields.forEach(field => {
      const current = +field.value || 0;
      const newMax = current + remaining;
      field.max = newMax;
      field.disabled = newMax === 0 && current === 0;
    });
  }

  updateHiddenInput() {
    const selected = [];

    this.deliveryDaysFields.forEach(input => {
      const day = input.name;
      const value = parseInt(input.value, 10);

      if (!isNaN(value) && value > 0) {
        selected.push(`${day} ${value}`);
      }
    });

    this.hiddenDaysInput.value = selected.join(', ');
    this.visibleDaysInput.innerHTML = "";
    selected.forEach(dayValueCouple => {
      const li = document.createElement("li");
      li.textContent = dayValueCouple;
      this.visibleDaysInput.appendChild(li);
    })
  }
}

customElements.define('fruechtebox-regularity', FruechteboxRegularity);
